if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
                
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;        
        
        let all_Products_Arr = [];
        formData.forEach(function (value, key) {
          //console.log(`value- ${value}: Key- ${key}`);
          if( key == 'id' || key == 'first_addon_product_id' || key == 'second_addon_product_id' ){
            if(value != ''){
              all_Products_Arr.push(
                { id: parseInt(value), quantity: 1 },
              );              
            }
          }
        });        
        //console.log('all_Products_Arr ', all_Products_Arr);
        all_Products_Arr = all_Products_Arr.reverse();
        // console.log('all_Products_Arr reversed', all_Products_Arr);
                
        if(all_Products_Arr.length == 1){
          
          //console.log('config', config);
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                //console.log('1');
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
  
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } 
              else if (!this.cart) {
                //console.log('2');
                window.location = window.routes.cart_url;
                return;
              }
  
              if (!this.error)
                //console.log('3');
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                //console.log('4');
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } 
              else {
                //console.log('5');              
                
                this.cart.renderContents(response);
                
                // Upsell app's code
                //console.log('Upsell app 1')
                upsellplusapp.init_drawer_offer();
                
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
               //console.log('6');
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');              
            });
        
        }else{
          
          //add items then show the cart
          let cartAddPayload = {
                                 items: all_Products_Arr,
                                 sections: this.cart.getSectionsToRender().map((section) => section.id),
                                 sections_url: window.location.pathname
                               }; 
          //console.log('cartAddPayload', cartAddPayload);
          
          const config_new = fetchConfig('javascript');
          config_new.headers['X-Requested-With'] = 'XMLHttpRequest';
          config_new.headers['Content-Type'] = 'application/json';
  
          config_new.body = JSON.stringify(cartAddPayload);
          //console.log('config_new', config_new);
          
          fetch(`${routes.cart_add_url}`, config_new)
            .then(response => response.json())
            .then(data => {
              //console.log('addtoCart Success:', data);
              
              this.cart.renderContents(data);
              
              // Upsell app's code
              //console.log('Upsell app 2')
              upsellplusapp.init_drawer_offer();
              
            })
            .catch((error) => {
              console.error('Error:', error);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');              
            });

          
        }//else ends

        
        
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
